export const DEFAULT_BENEFIT = {
  admin_copay: "$",
  admin_coverage: "%",
  deductible: "$",
  deductible_met: "$",
  med_ben_notes: "",
  office_copay: "$",
  office_coverage: "%",
  out_of_pocket_max: "$",
  out_of_pocket_met: "$",
  product_copay: "$",
  product_coverage: "%",
}

export const NOTE_DROPDOWN = [
  { value: "", label: "Select a note..."},
  {value:"Scheduled", label: "Scheduled"},
  {value:"Need to Schedule", label:"Need to Schedule"},
  {value:"Need to Re-run", label:"Need to Re-run"},
  {value:"Pending Specialty Pharmacy", label: "Pending Specialty Pharmacy"},
  {value:"Pending Prior Authorization Approval", label:"Pending Prior Authorization Approval"},
  {value:"Requires Office Attention", label:"Requires Office Attention"},
  {value:"Office Authorization Required", label:"Office Authorization Required"},
  {value:"Copay Card Needed", label:"Copay Card Needed"},
  {value:"Third Party Block", label:"Third Party Block"},
  {value:"Patient Needs to Call Pharmacy", label:"Patient Needs to Call Pharmacy"},
  {value:"Unable to Reach Patient", label:"Unable to Reach Patient"},
  {value:"Office Need to Call Pharmacy", label:"Office Need to Call Pharmacy"},
  {value:"Offices Needs to Verify Fee Schedule", label:"Offices Needs to Verify Fee Schedule"},
  {value:"Office Needs to Update Insurance",label:"Office Needs to Update Insurance"},
  {value:"Pending P&T Approval",label:"Pending P&T Approval"},
  {value:"Pre-Certification Required",label:"Pre-Certification Required"}
]
